import './LabGuide.css';

// Simple SVG icons
const HeartIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
    </svg>
);

const ThyroidIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
    </svg>
);

const ShieldIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    </svg>
);

const ZapIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
    </svg>
);

const FlameIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"></path>
    </svg>
);

const PillIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M10.5 20.5l10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7z"></path>
        <path d="M8.5 8.5l7 7"></path>
    </svg>
);

const ActivityIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
    </svg>
);

const DropletIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"></path>
    </svg>
);

const SearchIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
);

const CircleIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10"></circle>
    </svg>
);

export function LabGuide() {
    return (
        <div className="lab-guide-page">
            <header className="lab-guide-nav">
                <a href="/" className="logo">nostavia</a>
                <button className="print-btn" onClick={() => window.print()}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                        <polyline points="7 10 12 15 17 10"></polyline>
                        <line x1="12" y1="15" x2="12" y2="3"></line>
                    </svg>
                    Download PDF
                </button>
            </header>

            <main className="lab-guide-content">
                <div className="lab-guide-hero">
                    <span className="badge">Lab Panel Reference</span>
                    <h1>Nostavia Health Panel</h1>
                    <p className="hero-subtitle">
                        60 essential biomarkers covering heart, thyroid, immune, hormone, metabolic,
                        nutrient, liver, kidney, inflammation, and blood health.
                    </p>
                    <p className="hero-note">
                        Take this list to any major lab — Quest, LabCorp, or your local provider.
                    </p>
                </div>

                <div className="biomarkers-grid">
                    <div className="biomarker-card">
                        <div className="card-header">
                            <div className="card-icon"><HeartIcon /></div>
                            <div className="card-title">
                                <h3>Heart Health</h3>
                                <span className="count">9 biomarkers</span>
                            </div>
                        </div>
                        <ul>
                            <li>Total Cholesterol</li>
                            <li>LDL Cholesterol</li>
                            <li>HDL Cholesterol</li>
                            <li>Triglycerides</li>
                            <li>VLDL Cholesterol</li>
                            <li>Apolipoprotein B (ApoB)</li>
                            <li>Lipoprotein (a)</li>
                            <li>Creatine Kinase (CK)</li>
                            <li>Homocysteine</li>
                        </ul>
                    </div>

                    <div className="biomarker-card">
                        <div className="card-header">
                            <div className="card-icon"><ThyroidIcon /></div>
                            <div className="card-title">
                                <h3>Thyroid Health</h3>
                                <span className="count">4 biomarkers</span>
                            </div>
                        </div>
                        <ul>
                            <li>Thyroid-Stimulating Hormone (TSH)</li>
                            <li>Free Thyroxine (T4)</li>
                            <li>Free Triiodothyronine (T3)</li>
                            <li>Prolactin</li>
                        </ul>
                    </div>

                    <div className="biomarker-card">
                        <div className="card-header">
                            <div className="card-icon"><ShieldIcon /></div>
                            <div className="card-title">
                                <h3>Immune Regulation</h3>
                                <span className="count">6 biomarkers</span>
                            </div>
                        </div>
                        <ul>
                            <li>White Blood Cells (WBC)</li>
                            <li>Neutrophils</li>
                            <li>Lymphocytes</li>
                            <li>Monocytes</li>
                            <li>Eosinophils</li>
                            <li>Basophils</li>
                        </ul>
                    </div>

                    <div className="biomarker-card">
                        <div className="card-header">
                            <div className="card-icon"><ZapIcon /></div>
                            <div className="card-title">
                                <h3>Hormone Health</h3>
                                <span className="count">7 biomarkers</span>
                            </div>
                        </div>
                        <ul>
                            <li>Total Testosterone</li>
                            <li>Free Testosterone</li>
                            <li>Estradiol (E2)</li>
                            <li>Follicle-Stimulating Hormone (FSH)</li>
                            <li>Luteinizing Hormone (LH)</li>
                            <li>Progesterone</li>
                            <li>Cortisol</li>
                        </ul>
                    </div>

                    <div className="biomarker-card">
                        <div className="card-header">
                            <div className="card-icon"><FlameIcon /></div>
                            <div className="card-title">
                                <h3>Metabolic Health</h3>
                                <span className="count">4 biomarkers</span>
                            </div>
                        </div>
                        <ul>
                            <li>Fasting Glucose</li>
                            <li>Hemoglobin A1c (HbA1c)</li>
                            <li>Insulin</li>
                            <li>Uric Acid</li>
                        </ul>
                    </div>

                    <div className="biomarker-card">
                        <div className="card-header">
                            <div className="card-icon"><PillIcon /></div>
                            <div className="card-title">
                                <h3>Nutrients</h3>
                                <span className="count">5 biomarkers</span>
                            </div>
                        </div>
                        <ul>
                            <li>Vitamin D (25-OH)</li>
                            <li>Vitamin B12</li>
                            <li>Iron</li>
                            <li>Iron Binding Capacity</li>
                            <li>Iron % Saturation</li>
                        </ul>
                    </div>

                    <div className="biomarker-card">
                        <div className="card-header">
                            <div className="card-icon"><ActivityIcon /></div>
                            <div className="card-title">
                                <h3>Liver Health</h3>
                                <span className="count">7 biomarkers</span>
                            </div>
                        </div>
                        <ul>
                            <li>Aspartate Transaminase (AST)</li>
                            <li>Alanine Aminotransferase (ALT)</li>
                            <li>Alkaline Phosphatase (ALP)</li>
                            <li>Gamma-glutamyl Transferase (GGT)</li>
                            <li>Total Bilirubin</li>
                            <li>Albumin</li>
                            <li>Total Protein</li>
                        </ul>
                    </div>

                    <div className="biomarker-card">
                        <div className="card-header">
                            <div className="card-icon"><DropletIcon /></div>
                            <div className="card-title">
                                <h3>Kidney Health</h3>
                                <span className="count">6 biomarkers</span>
                            </div>
                        </div>
                        <ul>
                            <li>Blood Urea Nitrogen (BUN)</li>
                            <li>Creatinine</li>
                            <li>Sodium</li>
                            <li>Potassium</li>
                            <li>Chloride</li>
                            <li>Calcium</li>
                        </ul>
                    </div>

                    <div className="biomarker-card">
                        <div className="card-header">
                            <div className="card-icon"><SearchIcon /></div>
                            <div className="card-title">
                                <h3>Inflammation</h3>
                                <span className="count">2 biomarkers</span>
                            </div>
                        </div>
                        <ul>
                            <li>High-Sensitivity C-Reactive Protein (hsCRP)</li>
                            <li>Homocysteine</li>
                        </ul>
                    </div>

                    <div className="biomarker-card">
                        <div className="card-header">
                            <div className="card-icon"><CircleIcon /></div>
                            <div className="card-title">
                                <h3>Blood Health</h3>
                                <span className="count">9 biomarkers</span>
                            </div>
                        </div>
                        <ul>
                            <li>Red Blood Cell (RBC) Count</li>
                            <li>Hemoglobin</li>
                            <li>Hematocrit</li>
                            <li>Mean Corpuscular Volume (MCV)</li>
                            <li>Mean Corpuscular Hemoglobin (MCH)</li>
                            <li>Mean Corpuscular Hemoglobin Concentration (MCHC)</li>
                            <li>Red Cell Distribution Width (RDW)</li>
                            <li>Platelet Count</li>
                            <li>Total CO2</li>
                        </ul>
                    </div>
                </div>

                <footer className="lab-guide-footer">
                    <p>Print this page or download as PDF to bring to your lab appointment.</p>
                    <a href="/" className="back-link">← Back to Nostavia Health</a>
                </footer>
            </main>
        </div>
    );
}
